import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import ExtracaoIcmsStForm from "./ExtracaoIcmsStForm";
import ModalFilaCsvDinamica from "../ModalFilaCsvDinamica/ModalFilaCsvDinamica";
import Loading from "../Loading";
import { buscarRelatoriosPorCodigo } from "../../services/api-relatorios.service";

/**
 * Modal dedicada à extração ICMS-ST (lista do Extrator).
 * Sempre busca filtros e nome atualizados na API ao abrir (`GET /relatorios/buscar-por-codigo/:codigo`).
 */
export default function ModalExtracaoIcmsSt({
  open,
  onClose,
  idRelatorio,
  codigoRelatorio,
  nomeRelatorio,
  onSucesso,
}) {
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [filtros, setFiltros] = useState(undefined);
  const [relatorioCompleto, setRelatorioCompleto] = useState(null);
  const [nomeExibicao, setNomeExibicao] = useState(nomeRelatorio || "");
  /** Preferência pelo id retornado em GET /buscar-por-codigo (fonte de verdade). */
  const [idRelatorioResolvido, setIdRelatorioResolvido] = useState(undefined);

  const handleFinished = (sucesso, mensagem) => {
    if (sucesso) {
      onSucesso?.(mensagem);
      onClose();
    }
  };

  useEffect(() => {
    if (!open || !codigoRelatorio) {
      return;
    }

    let cancelled = false;
    setLoading(true);
    setErro(null);
    setFiltros(undefined);
    setRelatorioCompleto(null);
    setNomeExibicao(nomeRelatorio || "");
    setIdRelatorioResolvido(undefined);

    (async () => {
      try {
        const response = await buscarRelatoriosPorCodigo(codigoRelatorio);
        const rel = response?.relatorios?.[0];
        if (cancelled) return;
        if (!rel) {
          setErro("Relatório não encontrado.");
          setFiltros([]);
          return;
        }
        setFiltros(rel.filtros ?? []);
        setRelatorioCompleto(rel);
        setNomeExibicao(rel.nome || nomeRelatorio || "");
        const rid = rel.idRelatorio;
        setIdRelatorioResolvido(
          rid != null &&
            rid !== "" &&
            Number.isFinite(Number(rid))
            ? Number(rid)
            : idRelatorio
        );
      } catch (e) {
        if (!cancelled) {
          setErro(
            e?.response?.data?.mensagem ||
              e?.message ||
              "Não foi possível carregar o relatório."
          );
          setFiltros([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [open, codigoRelatorio, nomeRelatorio, idRelatorio]);

  const titulo = nomeExibicao || nomeRelatorio || "ICMS-ST";
  const mostrarFormulario = !loading && filtros !== undefined && !erro;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <h4 style={{ margin: 0 }}>{titulo}</h4>
      </DialogTitle>
      <DialogContent>
        <Loading loading={loading} />
        {erro && (
          <Typography color="error" sx={{ py: 2 }}>
            {erro}
          </Typography>
        )}
        {mostrarFormulario &&
          (relatorioCompleto?.processaFilaCsv ? (
            <ModalFilaCsvDinamica
              relatorio={relatorioCompleto}
              onClose={onClose}
              onFinished={handleFinished}
            />
          ) : (
            <ExtracaoIcmsStForm
              idRelatorio={
                idRelatorioResolvido !== undefined
                  ? idRelatorioResolvido
                  : idRelatorio
              }
              filtros={filtros}
              onClose={onClose}
              onFinished={handleFinished}
            />
          ))}
      </DialogContent>
    </Dialog>
  );
}
